export default __webpack_public_path__ + "static/media/DSC01073.0a3bdb51.jpg";